import { render, staticRenderFns } from "./dropdown.vue?vue&type=template&id=f50e82d8&scoped=true&lang=pug&xmlns=true"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"
import style0 from "./dropdown.vue?vue&type=style&index=0&id=f50e82d8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50e82d8",
  null
  
)

export default component.exports